import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { arlTableData, determineIfIsArlTableDataOrGroupEnd, groupEndPlaceholder } from '../../arl-table.component';
import {
    AccountsReceivableLedgerEntity, AccountsReceivableLedgerTypeEnum, isBookingPositionTypeEnum,
} from '../../../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { HintIconComponent } from '../../../../../../hint-icon/hint-icon.component';

@Component({
    selector: 'app-arl-table-cell-edit-button',
    standalone: true,
    imports: [CommonModule, MatLegacyButtonModule, FontAwesomeModule, MatLegacyMenuModule, HintIconComponent],
    templateUrl: './arl-table-cell-edit-button.component.html',
    styleUrls: ['./arl-table-cell-edit-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlTableCellEditButtonComponent {
    protected groupRowData: groupEndPlaceholder
    protected positionRowData: arlTableData<AccountsReceivableLedgerEntity>;
    @Input() set rowData(v: arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder) {
        if (determineIfIsArlTableDataOrGroupEnd(v)) {
            this.groupRowData = null;
            this.positionRowData = v;
        } else {
            this.groupRowData = v;
            this.positionRowData = null;
        }
    }
    @Input() _disabled: boolean;
    @Input() disableMove: boolean;
    @Input() syncCostAmountAndBaseCost: boolean;

    @Output() onCollapseRowClick = new EventEmitter<void>;
    @Output() onAllowanceClick = new EventEmitter<void>;
    @Output() onChargeClick = new EventEmitter<void>;
    @Output() onChargeOverrideClick = new EventEmitter<void>;
    @Output() onToggleOptional = new EventEmitter<void>;
    @Output() onToggleCrossedOut = new EventEmitter<void>;
    @Output() onCopyClick = new EventEmitter<void>;
    @Output() onMoveClick = new EventEmitter<void>;
    @Output() onToggleStartOnNewPage = new EventEmitter<void>;
    @Output() onDeleteClick = new EventEmitter<void>;
    @Output() onToggleFixedPrice = new EventEmitter<void>;
    @Output() onSplitClick = new EventEmitter<void>;

    protected readonly AccountsReceivableLedgerTypeEnum = AccountsReceivableLedgerTypeEnum;
    protected readonly isBookingPositionTypeEnum = isBookingPositionTypeEnum;
}
